import { useMutation } from 'react-query';
import axios from 'axios';
import config from '../config';

const apiClient = axios.create({
  baseURL: config.apiBaseUrl,
});

interface SubmissionPayload {
  type: string;
  venueId?: number;
  venueData: string; // JSON string
  source: string;
  submitterName: string;
  submitterEmail: string;
  photos: File[];
  photoCredits: string[];
  photoCaptions: string[];
  recaptchaToken?: string;
}

export const useCreateSubmissionMutation = ({ onSuccess }: { onSuccess(): void }) => {
  return useMutation({
    onSuccess,
    mutationFn: async (payload: SubmissionPayload) => {
      const formData = new FormData();
      formData.append('type', payload.type);
      if (payload.venueId) formData.append('venueId', String(payload.venueId));
      formData.append('venueData', payload.venueData);
      formData.append('source', payload.source);
      formData.append('submitterName', payload.submitterName);
      formData.append('submitterEmail', payload.submitterEmail);

      if (payload.recaptchaToken) {
        formData.append('recaptchaToken', payload.recaptchaToken);
      }

      payload.photos.forEach((file) => {
        formData.append('photos', file);
      });
      payload.photoCredits.forEach((credit) => {
        formData.append('photoCredits', credit);
      });
      payload.photoCaptions.forEach((caption) => {
        formData.append('photoCaptions', caption);
      });

      return apiClient.post('/api/submission', formData);
    },
  });
};
